import { connect } from 'react-redux'
import ProviderList from '../components/ProviderList'
import { listProvider } from '../ProviderActions'


const mapStateToProps = (state) => {
    return {
    	list_provider: state.provider.list_provider
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        listProvider:(network=null, date=null) => {
            return dispatch(listProvider(network, date))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProviderList)



// WEBPACK FOOTER //
// ./src/provider/containers/ProviderListContainer.js